import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: '首页'
			}
		},
		{
			path: '/clue',
			name: 'Member',
			component: () => import('./views/clue/Member.vue'),
			meta: {title: '咨询管理'}
		},
		{
			path: '/common',
			name: 'CommonBank',
			component: () => import('./views/clue/CommonBank.vue'),
			meta: {title: '公共库'}
		},
		{
			path: '/follow',
			name: 'FollowRecord',
			component: () => import('./views/clue/FollowRecord.vue'),
			meta: {title: '跟进记录'}
		},
		{
			path: '/verified',
			name: 'Verified',
			component: () => import('./views/clue/Verified.vue'),
			meta: {title: '身份认证'}
		},
		{
			path: '/verifiedDetail/:id(\\d+)?',
			name: 'VerifiedDetail',
			props: true,
			component: () => import('./views/clue/VerifiedDetail.vue'),
			meta: {title: '身份详情'}
		},
		{
			path: '/readCardDetail',
			name: 'ReadCardDetail',
			props: true,
			component: () => import('./views/clue/ReadCardDetail.vue'),
			meta: {title: '刷卡认证'}
		},
		{
			path: '/myFollow',
			name: 'MyFollowRecord',
			component: () => import('./views/clue/MyFollowRecord.vue'),
			meta: {title: '我的跟进'}
		},
		{
			path: '/myMember',
			name: 'MyMember',
			component: () => import('./views/clue/MyMember.vue'),
			meta: {title: '我的咨询'}
		},
		{
			path: '/myMarket',
			name: 'MyMarket',
			component: () => import('./views/clue/MyMarket.vue'),
			meta: {title: '我的市场咨询'}
		},
		{
			path: '/market',
			name: 'Market',
			component: () => import('./views/clue/Market.vue'),
			meta: {title: '全部市场咨询'}
		},
		{
			path: '/clue/form/:id(\\d+)?',
			name: 'MemberForm',
			props: true,
			component: () => import('./views/clue/MemberForm.vue'),
			meta: {title: '咨询编辑'}
		},
		{
			path: '/clue/file/:id(\\d+)?',
			name: 'MemberFile',
			props: true,
			component: () => import('./views/clue/MemberFile.vue'),
			meta: {title: '档案详情'}
		},
		{
			path: '/file/form/:id(\\d+)?',
			name: 'FileForm',
			props: true,
			component: () => import('./views/clue/FileForm.vue'),
			meta: {title: '咨询编辑'}
		},
		{
			path: '/clue/detail/:id(\\d+)?',
			name: 'MemberDetail',
			props: true,
			component: () => import('./views/clue/MemberDetail.vue'),
			meta: {title: '咨询详情'}
		},
		{
			path: '/clue/detailOne/:id(\\d+)?',
			name: 'MemberDetailOne',
			props: true,
			component: () => import('./views/clue/MemberDetailOne.vue'),
			meta: {title: '咨询详情'}
		},
		{
			path: '/market/form/:id(\\d+)?',
			name: 'MarketForm',
			props: true,
			component: () => import('./views/clue/MarketForm.vue'),
			meta: {title: '新增市场'}
		},
		{
			path: '/career/form/:id(\\d+)?',
			name: 'CareerFrom',
			props: true,
			component: () => import('./views/clue/CareerFrom.vue'),
			meta: {title: '职场信息'}
		},
		// {
		//     path: '/edu/form/:id(\\d+)?',
		//     name: 'EducationFrom',
		//     props: true,
		//     component: () => import('./views/clue/EducationFrom.vue'),
		//     meta: {title: '学历信息'}
		// },
		{
			path: '/train/form/:id(\\d+)?',
			name: 'TrainFrom',
			props: true,
			component: () => import('./views/clue/TrainFrom.vue'),
			meta: {title: '培训信息'}
		},
		{
			path: '/relation/form/:id(\\d+)?',
			name: 'RelationForm',
			props: true,
			component: () => import('./views/clue/RelationForm.vue'),
			meta: {title: '家庭情况'}
		},
		{
			path: '/file',
			name: 'StudentFile',
			component: () => import('./views/clue/StudentFile.vue'),
			meta: {
				title: '学员档案',
				keepAlive: false
			}
		},
		{
			path: '/student/detail/:id(\\d+)?',
			name: 'StudentDetail',
			props: true,
			component: () => import('./views/clue/StudentDetail.vue'),
			meta: {title: '档案详情'}
		},
		{
			path: '/student/paper/:id(\\d+)?',
			name: 'ExamPaperDetailForm',
			props: true,
			component: () => import('./views/clue/ExamPaperDetailForm.vue'),
			meta: {title: '准考证编辑'}
		},
		{
			path: '/student/follow/:id(\\d+)?',
			name: 'StudentFollowRecord',
			props: true,
			component: () => import('./views/clue/StudentFollowRecord.vue'),
			meta: {title: '跟进记录'}
		},
		/*积分*/
		{
			path: '/point',
			name: 'MemberPoint',
			component: () => import('./views/point/MemberPoint.vue'),
			meta: {title: '学员积分'}
		},
		{
			path: '/mall',
			name: 'Mall',
			redirect: {name: 'PointGoods'},
			component: () => import( './views/point/Mall.vue'),
			meta: {
				title: '商城'
			},
			children: [
				{
					path: '',
					name: 'PointGoods',
					component: () => import( './views/point/Index.vue'),
					meta: {
						title: '积分商城',
					}
				},
				{
					path: '/mall/orderManage',
					name: 'PointOrder',
					component: () => import( './views/point/Order.vue'),
					meta: {
						title: '订单管理'
					}
				}
			]
		},
		/*仓库*/
		{
			path: '/goods',
			name: 'Goods',
			component: () => import('./views/warehouse/Goods.vue'),
			meta: {title: '物品配置', group: '仓库管理'}
		},
		{
			path: '/house/record',
			name: 'HouseRecord',
			component: () => import('./views/warehouse/HouseRecord.vue'),
			meta: {title: '出入库管理', group: '仓库管理'}
		},
		{
			path: '/house/detail',
			name: 'HouseDetail',
			component: () => import('./views/warehouse/HouseDetail.vue'),
			meta: {title: '出入库单', group: '仓库管理'}
		},
		{
			path: '/present',
			name: 'Present',
			component: () => import('./views/warehouse/Present.vue'),
			meta: {title: '礼品管理', group: '仓库管理'}
		},
		{
			path: '/present/apply',
			name: 'PresentApply',
			component: () => import('./views/warehouse/PresentApply.vue'),
			meta: {title: '礼品申请', group: '仓库管理'}
		},
		{
			path: '/present/apply/record',
			name: 'PresentApplyRecord',
			component: () => import('./views/warehouse/PresentApplyRecord.vue'),
			meta: {title: '申请记录', group: '仓库管理'}
		},
		{
			path: '/present/record',
			name: 'PresentRecord',
			component: () => import('./views/warehouse/PresentRecord.vue'),
			meta: {title: '礼品记录', group: '仓库管理'}
		},
		/*教务*/
		{
			path: '/score',
			name: 'Score',
			component: () => import('./views/teaching/score/Score.vue'),
			meta: {title: '成绩管理', group: '教务管理'}
		},
		{
			path: '/uploadScore',
			name: 'UploadScore',
			component: () => import('./views/teaching/score/UploadScore.vue'),
			meta: {title: '成绩管理', group: '教务管理'}
		},
		{
			path: '/classType',
			name: 'ClassType',
			component: () => import('./views/teaching/class/ClassType.vue'),
			meta: {title: '班级管理', group: '教务管理'}
		},
		{
			path: '/onlineCourse',
			name: 'OnlineCourse',
			component: () => import('./views/teaching/online/OnlineCourse.vue'),
			meta: {title: '线上课程', group: '教务管理'}
		},
		{
			path: '/onlineLive/:onlineId(\\d+)?',
			name: 'OnlineLive',
			props: true,
			component: () => import('./views/teaching/online/OnlineLive.vue'),
			meta: {title: '排课', group: '教务管理'}
		},
		{
			path: '/classView/:clazzId(\\d+)?',
			name: 'ClassView',
			props: true,
			component: () => import('./views/teaching/class/ClassView.vue'),
			meta: {title: '班级管理', group: '教务管理'}
		},
		{
			path: '/classType/form/:id(\\d+)?',
			name: 'ClassTypeForm',
			props: true,
			component: () => import('./views/teaching/class/ClassTypeForm.vue'),
			meta: {title: '班级信息', group: '班级管理'}
		},
		{
			path: '/courseWareSend/:id(\\d+)?',
			name: 'CourseWareSend',
			props: true,
			component: () => import('./views/teaching/class/CourseWareSend.vue'),
			meta: {title: '班级管理', group: '教务管理'}
		},
		{
			path: '/classRoster/:id(\\d+)?',
			name: 'ClassRoster',
			props: true,
			component: () => import('./views/teaching/class/ClassRoster.vue'),
			meta: {title: '班级名册', group: '班级管理'}
		},
		{
			path: '/rosterForm',
			name: 'ClassRosterForm',
			props: true,
			component: () => import('./views/teaching/class/ClassRosterForm.vue'),
			meta: {title: '内容编辑', group: '班级管理'}
		},
		{
			path: '/paperForm',
			name: 'ClassExamPaperForm',
			props: true,
			component: () => import('./views/teaching/class/ClassExamPaperForm.vue'),
			meta: {title: '考试编辑', group: '班级管理'}
		},
		{
			path: '/diplomaForm',
			name: 'ClassExamDiplomaForm',
			props: true,
			component: () => import('./views/teaching/class/ClassExamDiplomaForm.vue'),
			meta: {title: '毕业证编辑', group: '班级管理'}
		},
		{
			path: '/exam/results/:id(\\d+)?',
			name: 'ExamResults',
			props: true,
			component: () => import('./views/teaching/class/ExamResults.vue'),
			meta: {title: '成绩管理', group: '班级管理'}
		},
		{
			path: '/classGroup/:id(\\d+)?',
			name: 'ClassGroup',
			props: true,
			component: () => import('./views/teaching/class/ClassGroup.vue'),
			meta: {title: '分组管理', group: '班级管理'}
		},
		{
			path: '/runGroup/:id(\\d+)?',
			name: 'RunGroup',
			props: true,
			component: () => import('./views/teaching/class/RunGroup.vue'),
			meta: {title: '分组操作', group: '班级管理'}
		},
		{
			path: '/classGroup/detail/:id(\\d+)?',
			name: 'ClassGroupDetail',
			props: true,
			component: () => import('./views/teaching/class/ClassGroupDetail.vue'),
			meta: {title: '分组详情', group: '班级管理'}
		},
		{
			path: '/student',
			name: 'Student',
			component: () => import('./views/teaching/Student.vue'),
			meta: {title: '学员管理', group: '教务管理'}
		},
		{
			path: '/student/form/:id(\\d+)?',
			name: 'StudentForm',
			props: true,
			component: () => import('./views/teaching/StudentForm.vue'),
			meta: {title: '学员信息', group: '学员管理'}
		},
		{
			path: '/chapter',
			name: 'Chapter',
			component: () => import('./views/teaching/Chapter.vue'),
			meta: {title: '章节管理', group: '教务管理'}
		},
		{
			path: '/addCourseSchedule/:id(\\d+)?',
			name: 'CourseScheduleForm',
			props: true,
			component: () => import('./views/teaching/schedule/CourseScheduleForm.vue'),
			meta: {title: '排课', group: '教务管理'}
		},
		{
			path: '/courseSchedule/:id(\\d+)?',
			name: 'CourseSchedule',
			props: true,
			component: () => import('./views/teaching/schedule/CourseSchedule.vue'),
			meta: {title: '课程表', group: '教务管理'}
		},
		{
			path: '/hoursChart',
			name: 'HoursChart',
			component: () => import('./views/teaching/schedule/HoursChart.vue'),
			meta: {title: '课时统计', group: '教务管理'}
		},
		{
			path: '/attendance/detail/:id(\\d+)?',
			name: 'AttendanceDetail',
			props: true,
			component: () => import('./views/teaching/schedule/AttendanceDetail.vue'),
			meta: {title: '考勤详情', group: '教务管理'}
		},
		{
			path: '/schedule/qrcode/:id(\\d+)?',
			name: 'ScheduleQrcode',
			props: true,
			component: () => import('./views/teaching/schedule/ScheduleQrcode.vue'),
			meta: {title: '二维码', group: '教务管理'}
		},
		{
			path: '/class/paper/:id(\\d+)?',
			name: 'ClassPaperList',
			props: true,
			component: () => import('./views/teaching/class/ClassPaperList.vue'),
			meta: {title: '班级试卷', group: '教务管理'}
		},
		{
			path: '/book',
			name: 'Book',
			props: true,
			component: () => import('./views/teaching/book/Book.vue'),
			meta: {title: '书籍管理', group: '教学管理'}
		},
		{
			path: '/runClass/:id(\\d+)?',
			name: 'RunClass',
			props: true,
			component: () => import('./views/teaching/class/RunClass.vue'),
			meta: {title: '学员分班', group: '教学管理'}
		},
		{
			path: '/changeDetail/:id(\\d+)?',
			name: 'ChangeClassDetail',
			props: true,
			component: () => import('./views/teaching/class/ChangeClassDetail.vue'),
			meta: {title: '班级记录', group: '教学管理'}
		},
		{
			path: '/waitClass',
			name: 'WaitClass',
			props: true,
			component: () => import('./views/teaching/class/WaitClass.vue'),
			meta: {title: '待分班学员', group: '教学管理'}
		},
		{
			path: '/classFollow',
			name: 'ClassFollow',
			props: true,
			component: () => import('./views/teaching/class/ClassFollow.vue'),
			meta: {title: '待分班学员', group: '教学管理'}
		},
		{
			path: '/quitSchool',
			name: 'QuitSchool',
			props: true,
			component: () => import('./views/teaching/quit/QuitSchool.vue'),
			meta: {title: '休学管理', group: '教学管理'}
		},
		{
			path: '/apply',
			name: 'ApplyToClass',
			props: true,
			component: () => import('./views/teaching/apply/ApplyToClass.vue'),
			meta: {title: '分班申请', group: '教务管理'}
		},
		{
			path: '/class/record/:id(\\d+)?',
			name: 'PaperRecordList',
			props: true,
			component: () => import('./views/teaching/class/PaperRecordList.vue'),
			meta: {title: '做题记录', group: '教务管理'}
		},
		{
			path: '/paper/answer/:id(\\d+)?',
			name: 'ClassPaperAnswer',
			props: true,
			component: () => import('./views/teaching/class/ClassPaperAnswer.vue'),
			meta: {title: '答题记录', group: '教务管理'}
		},
		{
			path: '/user/chat/:id(\\d+)?',
			name: 'UserChat',
			props: true,
			component: () => import('./views/teaching/userChat/UserChat.vue'),
			meta: {title: '班级问答', group: '教务管理'}
		},
		{
			path: '/user/question/:id(\\d+)?',
			name: 'ChatQuestionList',
			props: true,
			component: () => import('./views/teaching/userChat/ChatQuestionList.vue'),
			meta: {title: '问答列表', group: '教务管理'}
		},
		{
			path: '/user/question/info/:id(\\d+)?',
			name: 'ChatQuestionAnswer',
			props: true,
			component: () => import('./views/teaching/userChat/ChatQuestionAnswer.vue'),
			meta: {title: '问答记录', group: '教务管理'}
		},
		{
			path: '/class/paper/group/:id(\\d+)?',
			name: 'GroupPaper',
			props: true,
			component: () => import('./views/teaching/class/GroupPaper.vue'),
			meta: {title: '错误率统计', group: '班级试卷'}
		},
		{
			path: '/class/paper/detail/:id(\\d+)?',
			name: 'PaperGroupDetail',
			props: true,
			component: () => import('./views/teaching/class/PaperGroupDetail.vue'),
			meta: {title: '错误率详情', group: '班级试卷'}
		},
		{
			path: '/class/student/detail/:id?',
			name: 'StudentScheduleDetail',
			props: true,
			component: () => import('./views/teaching/schedule/StudentScheduleDetail.vue'),
			meta: {title: '打卡详情', group: '班级名册'}
		},
		{
			path: '/report/student',
			name: 'ReportStudent',
			component: () => import('./views/teaching/schedule/ReportStudent.vue'),
			meta: {title: '学员统计', group: '教学管理'}
		},
		{
			path: '/report/detail/:id?',
			name: 'ReportStudentDetail',
			props: true,
			component: () => import('./views/teaching/schedule/ReportStudentDetail.vue'),
			meta: {title: '学员详情', group: '学员统计'}
		},
		{
			path: '/course/ware/:id?',
			name: 'CourseWare',
			props: true,
			component: () => import('./views/teaching/CourseWare/CourseWare.vue'),
			meta: {title: '课件管理', group: '教务管理'}
		},
		/*财务*/
		{
			path: '/charge/:id(\\d+)?',
			name: 'Charge',
			props: true,
			component: () => import('./views/pay/Charge.vue'),
			meta: {title: '报名缴费', group: '财务管理'}
		},
		{
			path: '/charge/form',
			name: 'ChargeForm',
			props: true,
			component: () => import('./views/pay/ChargeForm.vue'),
			meta: {title: '报名缴费', group: '财务管理'}
		},
		{
			path: '/way/detail/:id(\\d+)?',
			name: 'PayWayDetail',
			props: true,
			component: () => import('./views/pay/PayWayDetail.vue'),
			meta: {title: '账户统计', group: '财务管理'}
		},
		{
			path: '/way/earning',
			name: 'Earning',
			props: true,
			component: () => import('./views/pay/Earning.vue'),
			meta: {title: '收入统计', group: '财务管理'}
		},
		{
			path: '/group/case',
			name: 'GroupCase',
			props: true,
			component: () => import('./views/pay/GroupCase.vue'),
			meta: {title: '套餐统计', group: '财务管理'}
		},
		{
			path: '/group/caseDetail',
			name: 'GroupCaseDetail',
			props: true,
			component: () => import('./views/pay/GroupCaseDetail.vue'),
			meta: {title: '套餐统计', group: '财务管理'}
		},
		{
			path: '/way/earnDetail',
			name: 'EarnDetail',
			props: true,
			component: () => import('./views/pay/EarnDetail.vue'),
			meta: {title: '班级详情', group: '财务管理'}
		},
		{
			path: '/debt',
			name: 'Debt',
			component: () => import('./views/pay/Debt.vue'),
			meta: {title: '欠款管理', group: '财务管理'}
		},
		{
			path: '/project/input',
			name: 'ProjectInput',
			component: () => import('./views/pay/ProjectInput.vue'),
			meta: {title: '项目收入', group: '财务管理'}
		},
		{
			path: '/refundDetail',
			name: 'RefundDetail',
			component: () => import('./views/pay/RefundDetail.vue'),
			meta: {title: '退费管理', group: '财务管理'}
		},
		{
			path: '/deleteRecord',
			name: 'DeleteRecord',
			component: () => import('./views/pay/DeleteRecord.vue'),
			meta: {title: '删除记录', group: '财务管理'}
		},
		{
			path: '/payDetail',
			name: 'PayDetail',
			component: () => import('./views/pay/PayDetail.vue'),
			meta: {title: '交易明细', group: '财务管理'}
		},
		{
			path: '/paymentRecord',
			name: 'PaymentRecord',
			component: () => import('./views/pay/PaymentRecord.vue'),
			meta: {title: '支付记录', group: '财务管理'}
		},
		{
			path: '/repayment/:id(\\d+)?',
			name: 'Repayment',
			props: true,
			component: () => import('./views/pay/Repayment.vue'),
			meta: {title: '学员补款', group: '财务管理'}
		},
		{
			path: '/single/detail/:id(\\d+)?',
			name: 'PaySingleDetail',
			props: true,
			component: () => import('./views/pay/PaySingleDetail.vue'),
			meta: {title: '交易详情', group: '财务管理'}
		},
		{
			path: '/refund/:id(\\d+)?',
			name: 'Refund',
			props: true,
			component: () => import('./views/pay/Refund.vue'),
			meta: {title: '学员退费', group: '财务管理'}
		},
		{
			path: '/recordDetail',
			name: 'RecordDetail',
			props: true,
			component: () => import('./views/pay/RecordDetail.vue'),
			meta: {title: '记录详情', group: '财务管理'}
		},
		{
			path: '/paySingleRecordDetail/:id(\\d+)?',
			name: 'PaySingleRecordDetail',
			props: true,
			component: () => import('./views/pay/PaySingleRecordDetail.vue'),
			meta: {title: '交易详情', group: '财务管理'}
		},
		{
			path: '/protocolRecord',
			name: 'ProtocolRecord',
			props: true,
			component: () => import('./views/pay/ProtocolRecord.vue'),
			meta: {title: '入读协议', group: '财务管理'}
		},
		{
			path: '/protocolForm',
			name: 'ProtocolCheckForm',
			props: true,
			component: () => import('./views/pay/ProtocolCheckForm.vue'),
			meta: {title: '协议审核', group: '财务管理'}
		},
		{
			path: '/protocolDetailForm',
			name: 'ProtocolDetailForm',
			props: true,
			component: () => import('./views/pay/ProtocolDetailForm.vue'),
			meta: {title: '协议编辑', group: '财务管理'}
		},
		{
			path: '/proofRecord',
			name: 'ProofRecord',
			props: true,
			component: () => import('./views/pay/ProofRecord.vue'),
			meta: {title: '缴费凭证', group: '财务管理'}
		},
		{
			path: '/statistics',
			name: 'Statistics',
			props: true,
			component: () => import('./views/pay/Statistics.vue'),
			meta: {title: '收入统计', group: '财务管理'}
		},
		{
			path: '/payPhoto',
			name: 'PayPhoto',
			props: true,
			component: () => import('./views/pay/PayPhoto.vue'),
			meta: {title: '成交留影', group: '财务管理'}
		},
		{
			path: '/stamp/:id(\\d+)?',
			name: 'Stamp',
			props: true,
			component: () => import('./views/pay/Stamp.vue'),
		},
		{
			path: '/detailStamp/:id(\\d+)?',
			name: 'PayDetailStamp',
			props: true,
			component: () => import('./views/pay/PayDetailStamp.vue'),
		},
		{
			path: '/payRecordStamp/:id(\\d+)?',
			name: 'PayRecordStamp',
			props: true,
			component: () => import('./views/pay/PayRecordStamp.vue'),
			meta: {title: '凭证打印'}
		},
		{
			path: '/payRecordDetail/:id(\\d+)?',
			name: 'PayRecordDetail',
			props: true,
			component: () => import('./views/pay/PayRecordDetail.vue'),
			meta: {title: '单据详情'}
		},
		/*支出管理*/
		{
			path: '/myExpend',
			name: 'MyExpend',
			component: () => import('./views/expend/MyExpend.vue'),
			meta: {title: '我的报销', group: '支出管理'}
		},
		{
			path: '/leader',
			name: 'LeaderAudit',
			component: () => import('./views/expend/LeaderAudit.vue'),
			meta: {title: '主管审核', group: '支出管理'}
		},
		{
			path: '/college',
			name: 'ExpendCollege',
			component: () => import('./views/expend/ExpendCollege.vue'),
			meta: {title: '审核主管', group: '支出管理'}
		},
		{
			path: '/card',
			name: 'ExpendCardNumber',
			component: () => import('./views/expend/ExpendCardNumber.vue'),
			meta: {title: '银行卡号', group: '支出管理'}
		},
		{
			path: '/expendLeader/:id(\\d+)?',
			name: 'ExpendLeaderAudit',
			props: true,
			component: () => import('./views/expend/ExpendLeaderAudit.vue'),
			meta: {title: '审核详情', group: '支出管理'}
		},
		{
			path: '/boss',
			name: 'BossAudit',
			component: () => import('./views/expend/BossAudit.vue'),
			meta: {title: '老板签字', group: '支出管理'}
		},
		{
			path: '/finance',
			name: 'FinancePay',
			component: () => import('./views/expend/FinancePay.vue'),
			meta: {title: '财务付款', group: '支出管理'}
		},
		{
			path: '/expendPay/:id(\\d+)?',
			name: 'ExpendFinancePay',
			props: true,
			component: () => import('./views/expend/ExpendFinancePay.vue'),
			meta: {title: '财务付款', group: '支出管理'}
		},
		{
			path: '/expendPayed/:id(\\d+)?',
			name: 'ExpendFinancePayed',
			props: true,
			component: () => import('./views/expend/ExpendFinancePayed.vue'),
			meta: {title: '财务付款', group: '支出管理'}
		},
		{
			path: '/financeAudit/:id(\\d+)?',
			name: 'ExpendFinanceAudit',
			props: true,
			component: () => import('./views/expend/ExpendFinanceAudit.vue'),
			meta: {title: '财务复核', group: '支出管理'}
		},
		{
			path: '/bossAudit',
			name: 'ExpendBossAudit',
			props: true,
			component: () => import('./views/expend/ExpendBossAudit.vue'),
			meta: {title: '签字详情', group: '支出管理'}
		},
		{
			path: '/bossAudited',
			name: 'ExpendBossAudited',
			props: true,
			component: () => import('./views/expend/ExpendBossAudited.vue'),
			meta: {title: '签字详情', group: '支出管理'}
		},
		{
			path: '/record',
			name: 'ExpendRecord',
			component: () => import('./views/expend/ExpendRecord.vue'),
			meta: {title: '报销记录', group: '支出管理'}
		},
		{
			path: '/record/from/:id(\\d+)?',
			name: 'ExpendRecordForm',
			props: true,
			component: () => import('./views/expend/ExpendRecordForm.vue'),
			meta: {title: '新增报销', group: '支出管理'}
		},
		{
			path: '/expend/bank',
			name: 'ExpendBankCard',
			props: true,
			component: () => import('./views/expend/ExpendBankCard.vue'),
			meta: {title: '付款账户', group: '支出管理'}
		},
		{
			path: '/expend/bank/Form',
			name: 'ExpendBankCardForm',
			props: true,
			component: () => import('./views/expend/ExpendBankCardForm.vue'),
			meta: {title: '账户操作', group: '支出管理'}
		},
		{
			path: '/record/detail/:id(\\d+)?',
			name: 'ExpendDetail',
			props: true,
			component: () => import('./views/expend/ExpendDetail.vue'),
			meta: {title: '报销详情', group: '支出管理'}
		},
		{
			path: '/record/catalog',
			name: 'ExpendCatalog',
			component: () => import('./views/expend/ExpendCatalog.vue'),
			meta: {title: '报销类别', group: '支出管理'}
		},
		/*教学管理*/
		{
			path: '/course',
			name: 'Course',
			component: () => import('./views/allocation/Course.vue'),
			meta: {title: '课程管理', group: '教务管理'}
		},
		{
			path: '/group',
			name: 'Group',
			props: true,
			component: () => import('./views/teaching/group/Group.vue'),
			meta: {title: '套餐管理', group: '教学管理'}
		},
		{
			path: '/project',
			name: 'Project',
			props: true,
			component: () => import('./views/teaching/project/Project.vue'),
			meta: {title: '项目管理', group: '教学管理'}
		},
		{
			path: '/bookConfig',
			name: 'BookConfig',
			props: true,
			component: () => import('./views/allocation/BookConfig.vue'),
			meta: {title: '教材配置', group: '教学管理'}
		},
		{
			path: '/bookManage',
			name: 'BookManage',
			props: true,
			component: () => import('./views/allocation/BookManage.vue'),
			meta: {title: '教材管理', group: '教学管理'}
		},
		{
			path: '/group/form/:id(\\d+)?',
			name: 'CourseGroup',
			props: true,
			component: () => import('./views/teaching/group/CourseGroup.vue'),
			meta: {title: '套餐内容', group: '教学管理'}
		},
		{
			path: '/group/detail/:id(\\d+)?',
			name: 'GroupDetail',
			props: true,
			component: () => import('./views/teaching/group/GroupDetail.vue'),
			meta: {title: '套餐内容', group: '教学管理'}
		},
		{
			path: '/subjectConfig',
			name: 'SubjectConfig',
			component: () => import('./views/allocation/SubjectConfig.vue'),
			meta: {title: '科目配置', group: '教务管理'}
		},
		{
			path: '/subjectManage',
			name: 'SubjectManage',
			component: () => import('./views/allocation/SubjectManage.vue'),
			meta: {title: '科目管理', group: '教务管理'}
		},
		{
			path: '/courseSubject/:id(\\d+)?',
			name: 'CourseSubject',
			props: true,
			component: () => import('./views/allocation/CourseSubject.vue'),
			meta: {title: '课程编辑', group: '教务管理'}
		},
		{
			path: '/courseDetail/:id(\\d+)?',
			name: 'CourseDetail',
			props: true,
			component: () => import('./views/allocation/CourseDetail.vue'),
			meta: {title: '课程详情', group: '教务管理'}
		},
		/*题库管理*/
		{
			path: '/list',
			name: 'QuestionList',
			component: () => import('./views/question/QuestionList.vue'),
			meta: {title: '题目管理', group: '题库管理'}
		},
		{
			path: '/form/:id(\\d+)?',
			name: 'QuestionForm',
			props: true,
			component: () => import('./views/question/QuestionForm.vue'),
			meta: {title: '题目信息', group: '题库管理'}
		},
		{
			path: '/paper',
			name: 'PaperList',
			component: () => import('./views/question/PaperList.vue'),
			meta: {title: '试题管理', group: '题库管理'}
		},
		{
			path: '/question/bank',
			name: 'QuestionBank',
			component: () => import('./views/QuestionBank/Question.vue'),
			meta: {title: '题目信息', group: '题库管理'}
		},
		{
			path: '/paper/Bank',
			name: 'PaperBank',
			component: () => import('./views/PaperBank/Index.vue'),
			meta: {title: '试卷管理', group: '题库管理'}
		},
		{
			path: '/paper/form/:id(\\d+)?',
			name: 'PaperForm',
			props: true,
			component: () => import('./views/question/PaperForm.vue'),
			meta: {title: '试题信息', group: '试题管理'}
		},
		{
			path: '/paper/compose/:id(\\d+)?',
			name: 'ComposeQuestion',
			props: true,
			component: () => import('./views/question/ComposeQuestion.vue'),
			meta: {title: '组合试卷', group: '试题管理'}
		},
		{
			path: '/query/compose/:id(\\d+)?',
			name: 'QueryComposeQuestion',
			props: true,
			component: () => import('./views/question/QueryComposeQuestion.vue'),
			meta: {title: '查看组卷', group: '试题管理'}
		},
		{
			path: '/node/:id(\\d+)?',
			name: 'NodeForm',
			props: true,
			component: () => import('./views/question/NodeForm.vue'),
			meta: {title: '修改节题目', group: '题库管理'}
		},
		/*系统管理 check-account*/
		{
			path: '/check-account',
			name: 'CheckAccount',
			component: () => import('./views/system/CheckAccount.vue'),
			meta: {title: '账号管理', group: '系统设置'},
		},
		{
			path: '/account/form/:id(\\d+)?',
			name: 'AccountForm',
			props: true,
			component: () => import('./views/system/AccountForm.vue'),
			meta: {title: '账号信息', group: '账号管理'}
		},
		{
			path: '/role',
			name: 'RoleList',
			component: () => import('./views/system/Role.vue'),
			meta: {title: '角色管理', group: '系统设置'}
		},
		{
			path: '/role/form/:id(\\d+)?',
			name: 'RoleForm',
			props: true,
			component: () => import('./views/system/RoleForm.vue'),
			meta: {title: '角色信息', group: '角色管理'}
		},
		{
			path: '/proceed/account/:id(\\d+)?',
			name: 'ProceedAccount',
			props: true,
			component: () => import('./views/system/ProceedAccount.vue'),
			meta: {title: '收款账户', group: '系统设置'}
		},
		{
			path: '/right',
			name: 'RightConfig',
			component: () => import('./views/system/Right.vue'),
			meta: {title: '权限配置', group: '系统设置'}
		},
		{
			path: '/dict',
			name: 'Dict',
			component: () => import('./views/system/Dict.vue'),
			meta: {title: '字典配置', group: '系统设置'}
		},
		{
			path: '/parameter',
			name: 'Parameter',
			component: () => import('./views/system/Parameter.vue'),
			meta: {title: '系统参数', group: '系统设置'}
		},
		{
			path: '/stampPreview',
			name: 'StampPreview',
			props: true,
			component: () => import('./views/system/StampPreview.vue'),
			meta: {title: '打印预览', group: '系统设置'}
		},
		{
			path: '/bannerShow',
			name: 'BannerShow',
			component: () => import('./views/applet/bannerShow/BannerShow.vue'),
			meta: {title: '轮播图管理', group: '小程序'}
		},
		{
			path: '/bannerShowForm/:id(\\d+)?',
			name: 'BannerShowForm',
			props: true,
			component: () => import('./views/applet/bannerShow/BannerShowForm.vue'),
			meta: {title: '轮播图信息', group: '小程序'}
		},
		{
			path: '/courseShow',
			name: 'CourseShow',
			props: true,
			component: () => import('./views/applet/courseShow/CourseShow.vue'),
			meta: {title: '展示课程', group: '小程序'}
		},
		{
			path: '/courseShowForm/:id(\\d+)?',
			name: 'CourseShowForm',
			props: true,
			component: () => import('./views/applet/courseShow/CourseShowForm.vue'),
			meta: {title: '展示课程信息', group: '小程序'}
		},
		{
			path: '/resources',
			name: 'Resources',
			component: () => import('./views/system/Resources.vue'),
			meta: {title: '资源管理'}
		},
		{
			path: '/personal',
			name: 'Personal',
			component: () => import('./views/personal/Index'),
			meta: {
				title: '个人设置'
			},
			children: [
				{
					path: 'personal-setting',
					name: 'PersonalSetting',
					component: () => import('./views/personal/PersonalSetting'),
					meta: {
						title: '个人设置'
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: () => import('./views/personal/ChangePassword'),
					meta: {
						title: '修改密码'
					}
				},
				{
					path: 'change-phone-number',
					name: 'ChangePhoneNumber',
					component: () => import('./views/personal/ChangePhoneNumber'),
					meta: {
						title: ''
					}
				}
			]
		},
		{
			path: '/activitys',
			name: 'Activitys',
			component: () => import('./views/activities/Activitys.vue'),
			meta: {title: '活动管理'}
		},
		{
			path: '/activity/task/:activityId(\\d+)?',
			name: 'ActivityIndex',
			props: true,
			component: () => import('./views/activities/ActivityIndex.vue'),
			meta: {title: '任务拆分'}
		},
		{
			path: '/activity/manage/:activityId(\\d+)?',
			name: 'ActivityManage',
			props: true,
			component: () => import('./views/activities/ActivityManage/ActivityManage.vue'),
			meta: {title: '名单管理'}
		},
		{
			path: '/activity/clue/manage',
			name: 'ActivityMemberManage',
			props: true,
			component: () => import('./views/activities/ActivityManage/ActivityMemberManage.vue'),
			meta: {title: '报名管理'}
		},
		{
			path: '/activity/progress',
			name: 'ActivityProgress',
			props: true,
			component: () => import('./views/activities/progress/ActivityProgress.vue'),
			meta: {title: '活动进度'}
		},
		{
			path: '/system/organization',
			name: 'Organization',
			props: true,
			component: () => import('./views/system/organization/Index.vue'),
			meta: {title: '组织架构'}
		},
		{
			path: '/system/account',
			name: 'SystemAccount',
			props: true,
			component: () => import('./views/system/Account.vue'),
			meta: {title: '学员账号'}
		},
		{
			path: '/graduate',
			name: 'Graduate',
			props: true,
			component: () => import('./views/graduate/Graduate.vue'),
			meta: {title: '资料收集'}
		},
		{
			path: '/primary',
			name: 'Primary',
			props: true,
			component: () => import('./views/collect/Primary.vue'),
			meta: {title: '初级采集', group: '教学管理'}
		},
		{
			path: '/primaryDetail',
			name: 'PrimaryDetail',
			props: true,
			component: () => import('./views/collect/PrimaryDetail.vue'),
			meta: {title: '初级采集', group: '教学管理'}
		},
		{
			path: '/graduate/detail',
			name: 'GraduateDetail',
			props: true,
			component: () => import('./views/graduate/GraduateDetail.vue'),
			meta: {title: '资料详情'}
		},

		/** 特殊**/
		{
			path: '/c/member',
			name: 'CMember',
			props: true,
			component: () => import('./views/special/CMember.vue'),
			meta: {title: '咨询管理'}
		},
		{
			path: '/c/pay',
			name: 'CPay',
			props: true,
			component: () => import('./views/special/CPaymentRecord.vue'),
			meta: {title: '财务管理'}
		},
		{
			path: '/c/group',
			name: 'CGroup',
			props: true,
			component: () => import('./views/special/CGroup.vue'),
			meta: {title: '套餐管理'}
		},
		{
			path: '/c/groupForm',
			name: 'CGroupForm',
			props: true,
			component: () => import('./views/special/CGroupForm.vue'),
			meta: {title: '套餐管理'}
		},
		{
			path: '/c/memberForm',
			name: 'CMemberForm',
			props: true,
			component: () => import('./views/special/CMemberForm.vue'),
			meta: {title: '套餐管理'}
		},
		{
			path: '/c/charge/:id(\\d+)?',
			name: 'CCharge',
			props: true,
			component: () => import('./views/special/CCharge.vue'),
			meta: {title: '套餐支付'}
		},
		{
			path: '/c/payDetail/:id(\\d+)?',
			name: 'CPayDetail',
			props: true,
			component: () => import('./views/special/CPayDetail.vue'),
			meta: {title: '支付详情'}
		},
		{
			path: '/c/repay/:id(\\d+)?',
			name: 'CRepay',
			props: true,
			component: () => import('./views/special/CRepay.vue'),
			meta: {title: '课程补款'}
		},
		{
			path: '/web/view/:id(\\d+)?',
			name: 'WebClazzView',
			props: true,
			component: () => import('./views/webClazz/WebClazzView.vue'),
			meta: {title: '网络班级'}
		},
		{
			path: '/web/clazz',
			name: 'WebClazz',
			props: true,
			component: () => import('./views/webClazz/WebClazz.vue'),
			meta: {title: '网络班级'}
		},
		{
			path: '/clazz/detail/:id(\\d+)?',
			name: 'WebClazzDetail',
			props: true,
			component: () => import('./views/webClazz/WebClazzDetail.vue'),
			meta: {title: '网络班级'}
		},
		{
			path: '/clazz/form',
			name: 'WebClazzForm',
			props: true,
			component: () => import('./views/webClazz/WebClazzForm.vue'),
			meta: {title: '网络班级'}
		},
		{
			path: '/follow/form',
			name: 'WebFollowForm',
			props: true,
			component: () => import('./views/webClazz/WebFollowForm.vue'),
			meta: {title: '网络班级'}
		},
		{
			path: '/wait/clazz',
			name: 'WaitWebClazz',
			props: true,
			component: () => import('./views/webClazz/WaitWebClazz.vue'),
			meta: {title: '网络待分班'}
		},
		{
			path: '/weiMarket',
			name: 'WeiMarket',
			props: true,
			component: () => import('./views/weiChat/WeiMarket.vue'),
			meta: {title: '意向管理'}
		},
		{
			path: '/staffAccount',
			name: 'StaffAccount',
			props: true,
			component: () => import('./views/weiChat/StaffAccount.vue'),
			meta: {title: '账号管理'}
		},
		{
			path: '/payShare',
			name: 'PayShare',
			props: true,
			component: () => import('./views/weiChat/PayShare.vue'),
			meta: {title: '提成管理'}
		},
		{
			path: '/shareForm',
			name: 'PayShareForm',
			props: true,
			component: () => import('./views/weiChat/PayShareForm.vue'),
			meta: {title: '提成编辑'}
		},
		{
			path: '/auditPay',
			name: 'AuditPayShare',
			props: true,
			component: () => import('./views/weiChat/AuditPayShare.vue'),
			meta: {title: '提成审核'}
		},
		{
			path: '/shareGrant',
			name: 'ShareGrant',
			props: true,
			component: () => import('./views/weiChat/ShareGrant.vue'),
			meta: {title: '提成发放'}
		},
		{
			path: '/shareDetail',
			name: 'ShareDetail',
			props: true,
			component: () => import('./views/weiChat/ShareDetail.vue'),
			meta: {title: '提成详情'}
		},
		{
			path: '/auditMarket',
			name: 'AuditMarket',
			props: true,
			component: () => import('./views/weiChat/AuditMarket.vue'),
			meta: {title: '意向确认'}
		},
		{
			path: '/auditMarketForm',
			name: 'AuditMarketForm',
			props: true,
			component: () => import('./views/weiChat/AuditMarketForm.vue'),
			meta: {title: '意向确认'}
		},
		{
			path: '/courseIntro',
			name: 'CourseIntro',
			props: true,
			component: () => import('./views/weiChat/CourseIntro.vue'),
			meta: {title: '课程展示'}
		},
		{
			path: '/courseMatter',
			name: 'CourseMatter',
			props: true,
			component: () => import('./views/weiChat/CourseMatter.vue'),
			meta: {title: '发圈素材'}
		},
		{
			path: '/myCompany',
			name: 'MyCompany',
			props: true,
			component: () => import('./views/company/MyCompany.vue'),
			meta: {title: '我的企服'}
		},
		{
			path: '/companyList',
			name: 'CompanyList',
			props: true,
			component: () => import('./views/company/CompanyList.vue'),
			meta: {title: '企业服务'}
		},
		{
			path: '/companyManage',
			name: 'CompanyManage',
			props: true,
			component: () => import('./views/company/CompanyManage.vue'),
			meta: {title: '企业权限'}
		},
	]
});
